export default __webpack_public_path__ + "media/images/images_v2/error-top-1d146108fb30a24ff1ab8c140aa43e46.png";